module.exports = __webpack_public_path__ + "img/240.0d9828c0.png";